var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F2F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8879 16.5747C22.0735 16.3702 22.3897 16.355 22.5942 16.5406C24.4995 18.2702 24.5496 21.1409 22.7058 22.9357C22.5079 23.1283 22.1913 23.1241 21.9987 22.9262C21.8061 22.7283 21.8104 22.4118 22.0083 22.2192C23.4389 20.8265 23.4005 18.6231 21.922 17.281C21.7176 17.0954 21.7023 16.7792 21.8879 16.5747ZM23.8162 13.693C24.0018 13.4885 24.318 13.4732 24.5225 13.6588C28.1197 16.9243 28.2141 22.332 24.733 25.7207C24.5351 25.9133 24.2186 25.909 24.026 25.7111C23.8333 25.5133 23.8376 25.1967 24.0355 25.0041C27.1034 22.0177 27.0207 17.2772 23.8503 14.3993C23.6459 14.2137 23.6306 13.8974 23.8162 13.693ZM25.7344 10.6639C25.92 10.4595 26.2362 10.4442 26.4407 10.6298C31.7298 15.4311 31.8685 23.3759 26.7501 28.3583C26.5522 28.5509 26.2357 28.5466 26.0431 28.3488C25.8505 28.1509 25.8547 27.8343 26.0526 27.6417C30.7578 23.0616 30.6308 15.784 25.7686 11.3702C25.5641 11.1846 25.5488 10.8684 25.7344 10.6639ZM10 17.6727C10 17.1204 10.4477 16.6727 11 16.6727H14.1905C14.1989 16.6727 14.2068 16.6699 14.213 16.665L18.6635 13.1665C18.9645 12.9299 19.3741 12.8859 19.7185 13.0532C20.0629 13.2206 20.2815 13.5698 20.2815 13.9527V26.3527C20.2815 26.7356 20.0629 27.0849 19.7185 27.2522C19.3741 27.4195 18.9645 27.3755 18.6635 27.1389L14.2032 23.6327H11C10.4477 23.6327 10 23.185 10 22.6327V17.6727ZM14.5492 22.6327L19.2815 26.3527V13.9527L14.831 17.4512C14.6484 17.5947 14.4229 17.6727 14.1905 17.6727H11V22.6327H14.5492Z",
    fill: "#0E0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundDefault);
export default __webpack_public_path__ + "static/media/sound-default.552f83b98536f0927cc63609f5ff5a0a.svg";
export { ForwardRef as ReactComponent };